var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70717 6.29289C7.31664 5.90237 6.68348 5.90237 6.29295 6.29289C5.90243 6.68342 5.90243 7.31658 6.29295 7.70711L10.5835 11.9977L6.29302 16.2874C5.90246 16.6778 5.9024 17.311 6.29289 17.7016C6.68338 18.0921 7.31654 18.0922 7.7071 17.7017L11.9977 13.4119L16.293 17.7071C16.6835 18.0976 17.3166 18.0976 17.7072 17.7071C18.0977 17.3166 18.0977 16.6834 17.7072 16.2929L13.4121 11.9978L17.6996 7.71108C18.0902 7.32059 18.0902 6.68743 17.6997 6.29687C17.3092 5.9063 16.6761 5.90625 16.2855 6.29673L11.9979 10.5836L7.70717 6.29289Z",
    fill: "#0D0802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.91c35d2571e9e080efeba4693e75312b.svg";
export { ForwardRef as ReactComponent };